import BaseContainer from "@base/container/BaseContainer"
import * as PIXI from "pixi.js";
import ScaleManager from "@/stage/ScaleManager"
import Facade from "@/Facade";
import {Signals} from "@/Imports"
import GameBackgroundContainer from "@/containers/GameBackgroundContainer";
import PlaneContainer from "@/containers/PlaneContainer";
import MultiplierContainer from "@/containers/MultiplierContainer";
import MakeBetsContainer from "@/containers/MakeBetsContainer";
import CurtainContainer from "@/containers/CurtainContainer";
import Config from "@/config/Config";
import Utils from "@base/utils/Utils";
import RewardContainer from "@/containers/RewardContainer";
import AxesContainer from "@/containers/AxesContainer";

export default class MainContainer extends BaseContainer {

  constructor() {
    super()
    this.isCreated = false
    this.interactive = false

    Facade.mainContainer = this

    this.init()

    Signals.continueBtnClick.add(this.onContinueBtnClick, this)
    Signals.chatVisibilityChange.add(this.onChatVisibilityChange, this)

    Signals.makeBets.add(this.onMakeBets, this)
  }

  init() {
    this.onOrientationChanged(Facade.orientation)

    this.generalContainer = new PIXI.Container()
    this.addChild(this.generalContainer)

    this.gameBackground = new GameBackgroundContainer()
    this.generalContainer.addChild(this.gameBackground)

    this.planeContainer = new PlaneContainer()
    this.generalContainer.addChild(this.planeContainer)

    this.axes = new AxesContainer()
    this.axes.name = "Axes"
    this.generalContainer.addChild(this.axes)

    this.multiplierContainerShadow = new MultiplierContainer({style: 'multiplierShadow'})
    this.generalContainer.addChild(this.multiplierContainerShadow)

    this.multiplierContainer = new MultiplierContainer()
    this.generalContainer.addChild(this.multiplierContainer)

    this.makeBetsContainer = new MakeBetsContainer()
    this.generalContainer.addChild(this.makeBetsContainer)

    this.curtainContainer = new CurtainContainer()
    this.generalContainer.addChild(this.curtainContainer)

    this.rewardContainer = new RewardContainer()
    this.generalContainer.addChild(this.rewardContainer)

    window.dispatchEvent(new Event('resize'))

    Signals.graphicsCreated.dispatch()

    this.setPositions()

    this.isCreated = true
  }

  onMakeBets() {
  }

  onContinueBtnClick() {
    Signals.chatVisibilityChange.dispatch(true)
  }

  onChatVisibilityChange(visible) {
    Facade.rootDIV = document.getElementById('root')
    Facade.rootDIV.style.visibility = visible ? "visible" : "hidden"
  }

  onOrientationChanged(orientationSymbol) {
    switch (orientationSymbol) {
      case 'Hm':
      case 'Vm':
      case 'Hd':
        Config.currentPattern = Config.pattern.desktop
        break
    }
    if (this.isCreated) {
      this.setPositions()
    }
  }

  setPositions() {
    //this.createGeneralMask()
    //this.createViewportMask()

    // TODO: Feature container
    Utils.applyFromPattern(this.makeBetsContainer, Config.currentPattern.makeBetsContainer)
    Utils.applyFromPattern(this.multiplierContainer, Config.currentPattern.multiplierContainer)

    this.multiplierContainer.y = 120
    this.multiplierContainer.x = 592
    this.multiplierContainerShadow.x = this.multiplierContainer.x - 10
    this.multiplierContainerShadow.y = this.multiplierContainer.y + 10
    this.generalContainer.x -= 100
    this.makeBetsContainer.x += 100

    switch (Facade.orientation) {
      case 'Hd':
        this.generalContainer.visible = true
        break

      case 'Hm':
        this.generalContainer.visible = false
        break

      case 'Vm':
        this.generalContainer.visible = true
        break
    }
  }

  createGeneralMask() {
    if (this.generalMask) {
      this.removeChild(this.generalMask)
      this.generalMask = null
    }
    this.generalMask = new PIXI.Graphics()
    this.generalMask.beginFill(0xffffff)
    this.generalMask.drawRect(0, 0, ScaleManager.currentSizes.total.width, ScaleManager.currentSizes.total.height)
    this.generalMask.endFill()
    this.mask = this.generalMask
    this.addChild(this.generalMask)
  }
}
